import { render, staticRenderFns } from "./TicketCategories.vue?vue&type=template&id=ce17e164&"
import script from "./TicketCategories.vue?vue&type=script&lang=js&"
export * from "./TicketCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports